import {IntegrationMessage} from "platform/integration/message/IntegrationMessage";
import {IntegrationClassId} from "platform/integration/message/IntegrationClassId";

export class IntegrationWinInitialized implements IntegrationMessage {

    public classId: number = IntegrationClassId.WIN_INITIALIZED;
}
